export const safeStorageGet = (key, onError) => {
  try {
    return window.localStorage.getItem(key);
  } catch (error) {
    if (typeof onError === 'function') {
      onError(error);
    }
    return null;
  }
};

export const safeStorageSet = (key, value) => {
  try {
    window.localStorage.setItem(key, value);
  } catch (error) {
    // Storage unavailable (private mode / blocked cookies).
  }
};
